<template>
  <van-pull-refresh v-model="loading" @refresh="refresh">
    <template #pulling>
      <p>下拉刷新...</p>
    </template>
    <template #loosing>
      <p>下拉刷新...</p>
    </template>
    <template #loading>
      <van-loading type="spinner" />
    </template>
    <slot></slot>
  </van-pull-refresh>
</template>

<script>
export default {
  name: 'PullRefresh',
  props: {
    refreshLoading: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    'refreshLoading' () {
      this.loading = this.refreshLoading
    }
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    refresh () {
      this.$emit('refresh', 'pull-refresh')
    }
  }
}
</script>

<style lang="less" scoped>
.icon-arrow {
  display: inline-block;
}
</style>
